module.exports = __webpack_public_path__ + "images/emoji/orange_book.5d0c97842a082ea5f2b4.png";